import React, { FC, ReactNode } from 'react'
import { injectIntl } from 'react-intl'

import { useProductContext } from '../context'
import RegularPrice from './RegularPrice'
import PromotionalPrice from './PromotionalPrice'
import DiscountPrice from './DiscountPrice'
import { ItemProductCart } from '../ProductSummary'
import PriceAvailabilityMessage from '../Message/PriceAvailabilityMessage'

export enum PriceType {
  Regular = 'regular',
  Discount = 'discount',
  Promotional = 'promotional',
}

export interface PriceProps {
  intl?: any
  availabilityText?: ReactNode
  loading: boolean
}
const Price: FC<PriceProps> = ({ intl, loading, availabilityText }) => {
  const { item } = useProductContext()
  const getPriceType = (item: ItemProductCart) => {
    if (item.type === 'promotional') {
      return PriceType.Promotional
    }

    const price = item.manualPrice ?? item.sellingPrice
    // @ts-expect-error ts-migrate(2533) FIXME: Object is possibly 'null' or 'undefined'.
    const withDiscount = price < item.listPrice

    if (withDiscount) {
      return PriceType.Discount
    }

    return PriceType.Regular
  }

  const priceType = getPriceType(item)

  const renderPrice = (type: PriceType, item: ItemProductCart) => {
    const { quantity, sellingPrice, listPrice, prices, index } = item

    switch (type) {
      case PriceType.Regular:
        return (
          <RegularPrice
            quantity={quantity}
            // @ts-expect-error ts-migrate(2322) FIXME: Type 'Optional<number>' is not assignable to type ... Remove this comment to see the full error message
            pricePerUnit={sellingPrice}
            intl={intl}
            // @ts-expect-error ts-migrate(2322) FIXME: Type 'Optional<number>' is not assignable to type ... Remove this comment to see the full error message
            index={index}
          />
        )

      case PriceType.Promotional:
        // @ts-expect-error ts-migrate(2322) FIXME: Type 'CustomPriceProps[] | undefined' is not assig... Remove this comment to see the full error message
        return <PromotionalPrice prices={prices} intl={intl} index={index} />

      case PriceType.Discount:
        return (
          <DiscountPrice
            // @ts-expect-error ts-migrate(2322) FIXME: Type 'Optional<number>' is not assignable to type ... Remove this comment to see the full error message
            price={listPrice}
            // @ts-expect-error ts-migrate(2322) FIXME: Type 'Optional<number>' is not assignable to type ... Remove this comment to see the full error message
            sellingPrice={sellingPrice}
            quantity={quantity}
            // @ts-expect-error ts-migrate(2322) FIXME: Type 'Optional<number>' is not assignable to type ... Remove this comment to see the full error message
            index={index}
          />
        )
    }
  }

  if (availabilityText) {
    return <PriceAvailabilityMessage text={availabilityText} />
  }

  return (
    <div className="flex flex-column pt5">
      {!loading ? (
        <div data-cy="product-summary__price">
          {renderPrice(priceType, item)}
        </div>
      ) : (
        <div className="flex flex-column pt3 h2-s h-auto-ns" />
      )}
    </div>
  )
}

// TODO: this error popped up when moving the checkout-instore project
// to checkout-instore-legacy, but needs to be fixed at some point
// @ts-ignore
export default injectIntl(Price)
